export default function unslugify(pathname, clamp = true) {
  // Remove leading and trailing slashes
  pathname = pathname.replace(/^\/|\/$/g, "");

  // Replace dashes with spaces
  pathname = pathname.replace(/-/g, " ");

  // Remove "project" prefix if present
  pathname = pathname.replace(/^projects\//, "");

  // Capitalize first letter of each word
  pathname = pathname.replace(/\b\w/g, function (char) {
    return char.toUpperCase();
  });

  // Cut string if it exceeds 12 characters and append "..."
  if (clamp) {
    if (pathname.length > 16) {
      pathname = pathname.substring(0, 16) + "...";
    }
  }

  return pathname;
}
